import { decodeEntities } from './parseFindings';

const PATTERN_RE = /<pattern\b[^>]*>([\s\S]*?)<\/pattern>/gi;

export function parsePatterns(text: string): string[] {
  const patterns: string[] = [];
  for (const match of text.matchAll(PATTERN_RE)) {
    const inner = (match[1] ?? '').trim();
    if (inner) patterns.push(decodeEntities(inner));
  }
  return patterns;
}
